import React from 'react'
import moment from 'moment'
import { Chip, CircularProgress } from '@mui/material'

type Props = {
  menuClosed: boolean
  openingTime?: string | null
  orderTimeRemaining?: moment.Duration | null
}

const OrderTimeLeft: React.FC<Props> = ({ menuClosed, openingTime, orderTimeRemaining }) => {
  let textTimeLeft = ''
  let textTimeLeftSuffix = ''
  const isNotYetOpen = moment().isBefore(moment(openingTime))

  if (isNotYetOpen) {
    textTimeLeft = `Opens ${moment(openingTime).format('ddd Do')}`
  } else if (menuClosed) {
    textTimeLeft = 'Closed'
  } else if (orderTimeRemaining && orderTimeRemaining.asDays() >= 1) {
    const durationDaysFloored = Math.floor(orderTimeRemaining.asDays())
    const durationText = durationDaysFloored > 1 ? 's' : ''
    const hours = orderTimeRemaining.hours()
    const hasHours = hours > 0
    const hoursText = hours > 1 ? 'hrs' : 'hr'
    textTimeLeft = `${durationDaysFloored} day${durationText} ${
      hasHours ? `${hours}${hoursText}` : ''
    }`
    textTimeLeftSuffix = ' left'
  } else if (orderTimeRemaining) {
    const hours =
      orderTimeRemaining.hours() < 10
        ? `0${orderTimeRemaining.hours()}`
        : orderTimeRemaining.hours()
    const minutes =
      orderTimeRemaining.minutes() < 10
        ? `0${orderTimeRemaining.minutes()}`
        : orderTimeRemaining.minutes()
    textTimeLeft = `${hours}:${minutes}`
    textTimeLeftSuffix = ' left'
  }

  return (
    <Chip
      sx={{ width: '100%' }}
      color="warning"
      size="medium"
      label={
        textTimeLeft ? (
          <>
            {textTimeLeft} {textTimeLeftSuffix}
          </>
        ) : (
          <CircularProgress size={15} />
        )
      }
    />
  )
}

export default OrderTimeLeft
